import { Route } from 'react-router-dom';
import { RouteLeafConfig } from '@/types/utils';

export function renderRouteLeaves(routes: readonly RouteLeafConfig[]) {
  return routes.map(({ path, Component }) => (
    <Route key={path} path={path} element={<Component />} />
  ));
}
